<template>
  <div class="root">
    <sc-image :media="fields.ThankYouImage" />

    <!-- Title -->
    <h2 v-if="!isSitecoreExperienceEditorOn" v-html="this.titleFieldValue">
    </h2>
    <h2 v-if="isSitecoreExperienceEditorOn">
      <sc-text :field="fields.ThankYouTitle" />
    </h2>

    <!-- Content -->
    <div class="sc-content" v-if="!isSitecoreExperienceEditorOn" v-html="this.contentFieldValue">
    </div>
    <div class="sc-content" v-if="isSitecoreExperienceEditorOn">
      <sc-rich-text :field="fields.ThankYouContent" />
    </div>
  </div>
</template>

<script>
import { Text, RichText, Image, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'thankyou',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
    };
  },
  components: {
    ScText: Text,
    ScRichText: RichText,
    ScImage: Image,
  },
  computed:{
    isSitecoreExperienceEditorOn() {
      return isExperienceEditorActive();
    },
    titleFieldValue() {
      if (
        this.fields.ThankYouTitle &&
        this.fields.ThankYouTitle.value
      ) {
        if(typeof(this.$route.query.reference)!='undefined'){
          return this.fields.ThankYouTitle.value.replace('{{thank_you_reference}}',this.$route.query.reference);
        }
        else{
          return this.fields.ThankYouTitle.value.replace('{{thank_you_reference}}','');
        }
      }
      return '';
    },
    contentFieldValue() {
      if (
        this.fields.ThankYouContent &&
        this.fields.ThankYouContent.value
      ) {
        if(typeof(this.$route.query.reference)!='undefined'){
          return this.fields.ThankYouContent.value.replace('{{thank_you_reference}}',this.$route.query.reference);
        }
        else{
          return this.fields.ThankYouContent.value.replace('{{thank_you_reference}}','');
        }
      }
      return '';
    },
  }
};
</script>

<style lang="scss" scoped>
.root {
  text-align: center;
  margin-top: 50px;
}
h2 {
  margin-top: 30px;
  margin-bottom: 30px;
}
.sc-content {
  margin-top: 50px !important;
}
</style>
